import { Injectable } from '@angular/core';
import { ApiService } from '../util/api.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { UsuarioResponse } from '../../service/model/response/usuarioResponse.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PdpjService {

  private basePath = environment.proxyPdpj

  constructor(private _apiService: ApiService) { }

  public getPerfilUsuario(user: string): Observable<HttpResponse<UsuarioResponse>> {
    return this._apiService.get(`${this.basePath}/usuarios/${user}/perfis`);
  }
}
